import apiClient from "./client";

export const getAdminTrainings = async ({ courseId }) => {
  const response = await apiClient.get(`/courses/${courseId}/trainings/admin`);
  return response.data;
};

export const createAdminTraining = async ({ courseId, payload }) => {
  const response = await apiClient.post(`/courses/${courseId}/trainings/admin`, payload);
  return response.data;
};

export const updateAdminTraining = async ({ courseId, trainingId, payload }) => {
  const response = await apiClient.put(`/courses/${courseId}/trainings/admin/${trainingId}`, payload);
  return response.data;
};

export const deleteAdminTraining = async ({ courseId, trainingId }) => {
  await apiClient.delete(`/courses/${courseId}/trainings/admin/${trainingId}`);
};

export const uploadAdminTrainingTrainerAvatar = async ({ courseId, trainingId, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(
    `/courses/${courseId}/trainings/admin/${trainingId}/trainer-avatar`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const removeAdminTrainingTrainerAvatar = async ({ courseId, trainingId }) => {
  const response = await apiClient.delete(
    `/courses/${courseId}/trainings/admin/${trainingId}/trainer-avatar`
  );
  return response.data;
};
